import React, { Component } from 'react';
import { Redirect } from 'react-router-dom'
import { getSinglePregnancyRecord, deletePregnancyImage } from '../../services';
import { ph, documentsType, cp, concieveMethod, subDocument } from '../configData'
import Loader from '../../Loader';
import EnhancedPregnancyRecord from './EnhancedPregnancyRecord';

class  EditPregnancyRecord extends Component {

  state = {
    loading: true,
    pregnancyRecord: '',
    pregnancyRecordId: '',
    files: []
  }

  async componentDidMount() {
    const recordId = this.props.match.params.id;
    
    let data = {
      recordId
    }

    console.log(this.props)
    const { state } = this.props.location;

    if(state == undefined) {
      this.setState(prevState => ({
        loading: false,
        redirect: true
      }));
      return;
    }

    // console.log(state);
    const response = await getSinglePregnancyRecord(data);

    let files = response.data.record.documentDetails.files.map((file, index) =>  {
      return {fileId: file._id, filename: file.filename, uploaded: true }
    })

    this.setState({
      loading: false,
      type: state.type,
      pregnancyRecord: response.data.record,
      pregnancyRecordId: recordId,
      files: files
    })
  }

  deleteImage = async (imageId) => {
    
    let data = {
      recordId: this.state.pregnancyRecordId,
      imageId
    }
    
    const response = await deletePregnancyImage({data});
    
    this.setState(prevState => ({
      files: prevState.files.filter((file) => file.fileId !== imageId)
    })) 
  }


  render() {

    const { loading } = this.state;

    if(loading == true) {
      return (
        <Loader />
      )
    }

    if(this.state.redirect == true) {
      return <Redirect to="/personalhealthrecord/pregnancyrecord" />
    }


    const { pregnancyRecord, type, files, pregnancyRecordId } = this.state;
    let documentType, documentsOption, lmd;

    if(type !== 2) {
      documentType = ph[pregnancyRecord.documentDetails.documentType]
      documentsOption = ph;
      lmd = null
    } else {
      documentType = documentsType[pregnancyRecord.pregnancyStage][pregnancyRecord.documentDetails.documentType]
      documentsOption = documentsType[pregnancyRecord.pregnancyStage];
      lmd = new Date(pregnancyRecord.lastMenstrualPeriodDate);
    }

    console.log(pregnancyRecord.documentDetails.documentType)
    console.log(documentType);

    return(
      <EnhancedPregnancyRecord
        recordId={pregnancyRecordId} 
        gyno={pregnancyRecord.gynecologistName}
        hospital={pregnancyRecord.hospitalName}
        phone={pregnancyRecord.phone}
        type={type}
        files={files}
        stage={cp[pregnancyRecord.pregnancyStage]}
        concieve={concieveMethod[pregnancyRecord.concieveMethod]}
        subTypeDocument={subDocument[pregnancyRecord.subtypeDocument]}
        lmd={lmd}
        documentType={ documentType }
        title={pregnancyRecord.documentDetails.title}
        description={pregnancyRecord.documentDetails.description}
        appointment={new Date(pregnancyRecord.documentDetails.appointment)}
        documentsOption={documentsOption}
        deleteImage={this.deleteImage}
        formType="edit"

      />
    );
  }


}


export  default  EditPregnancyRecord;



// WEBPACK FOOTER //
// ./src/views/PersonalHealthRecord/PregnancyRecord/EditPregnancyRecord.js